var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0396 1.99143C12.2521 1.7789 12.5967 1.7789 12.8092 1.99143L14.5099 3.69212C14.7225 3.90465 14.7225 4.24923 14.5099 4.46176L12.8092 6.16245C12.5967 6.37498 12.2521 6.37498 12.0396 6.16245C11.8271 5.94992 11.8271 5.60534 12.0396 5.3928L13.3555 4.07694L12.0396 2.76107C11.8271 2.54854 11.8271 2.20396 12.0396 1.99143Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96567 15.006C3.75314 15.2186 3.40855 15.2186 3.19602 15.006L1.49534 13.3053C1.2828 13.0928 1.2828 12.7482 1.49534 12.5357L3.19602 10.835C3.40855 10.6225 3.75314 10.6225 3.96567 10.835C4.1782 11.0475 4.1782 11.3921 3.96567 11.6046L2.6498 12.9205L3.96567 14.2364C4.1782 14.4489 4.1782 14.7935 3.96567 15.006Z",
    fill: "#4D4D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33594 4.07694C1.33594 3.77637 1.57959 3.53272 1.88016 3.53272L14.1251 3.53272C14.4257 3.53272 14.6693 3.77637 14.6693 4.07694C14.6693 4.3775 14.4257 4.62116 14.1251 4.62116L2.42438 4.62116L2.42438 8.49873C2.42438 8.79929 2.18072 9.04295 1.88016 9.04295C1.57959 9.04295 1.33594 8.79929 1.33594 8.49873L1.33594 4.07694Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5099 13.3053C14.4079 13.4074 14.2694 13.4647 14.1251 13.4647L1.88016 13.4647C1.57959 13.4647 1.33594 13.2211 1.33594 12.9205C1.33594 12.6199 1.57959 12.3763 1.88016 12.3763L13.5809 12.3763L13.5809 8.49873C13.5809 8.19816 13.8245 7.95451 14.1251 7.95451C14.4257 7.95451 14.6693 8.19816 14.6693 8.49873L14.6693 12.9205C14.6693 13.0648 14.612 13.2033 14.5099 13.3053Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIcon);
export default __webpack_public_path__ + "static/media/swap-icon.151902250c4673f145dbf2aa41ab29f1.svg";
export { ForwardRef as ReactComponent };